import styled from 'styled-components';

export const StyledUserAdminNav = styled.div`
  border-right: 1px solid #e6e7eb;

  p {
    margin-bottom: 0px;
  }

  .logo {
    width: 100%;
    height: 82px;
    padding: 22px 0 22px 20px;
    border-bottom: 1px solid #e6e7eb;
  }

  .menu {
    width: 257px;
  }

  .menu-title {
    display: flex;
    height: 44px;
    padding-left: 22px;
    gap: 12px;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.5%;
    vertical-align: middle;
  }

  .sub-menu {
    display: block;
    display: flex;
    height: 48px;
    padding-left: 52px;
    align-items: center;
    background-color: #fafafa;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.5%;
    cursor: pointer;

    &.active {
      font-weight: 500;
      color: #1890ff;
    }
  }
`;

export const StyledAdminHeader = styled.div`
  display: flex;
  background-color: rgb(59, 89, 152);
  height: 50px;
  justify-content: flex-end;
  color: white;
  align-items: center;
  padding-right: 20px;

  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;

  p {
    margin-bottom: 0px;
  }

  > div {
    display: flex;
    gap: 4px;
    align-items: center;
    cursor: pointer;
  }
`;
